export default "__VITE_ASSET__MRjRKhFR__"